export default "__VITE_ASSET__090916e9__"